'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _OutlineModal = require('./OutlineModal');

var _OutlineModal2 = _interopRequireDefault(_OutlineModal);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _Button = require('../../Button');

var _Button2 = _interopRequireDefault(_Button);

var _withKeyboardEvent = require('../../../decorators/withKeyboardEvent');

var _withKeyboardEvent2 = _interopRequireDefault(_withKeyboardEvent);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = {
  modal: {},
  content: {
    outline: 'none',
    backgroundColor: '#fff',
    padding: 20
  },
  title: {
    fontSize: 26,
    fontWeight: 700,
    marginBottom: 10
  },
  message: {
    marginBottom: 20
  },
  buttons: {
    textAlign: 'right'
  },
  cancelButton: {
    marginRight: 10
  }
};

var Modal = (_dec = (0, _withKeyboardEvent2.default)('enter', 'confirm'), _dec(_class = (_class2 = (_temp2 = _class3 = function (_React$Component) {
  (0, _inherits3.default)(Modal, _React$Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Modal, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        showModal: this.showModal
      };
    }
  }, {
    key: 'showModal',
    value: function showModal(_ref2) {
      var title = _ref2.title,
          message = _ref2.message,
          confirm = _ref2.confirm,
          confirmText = _ref2.confirmText,
          cancelText = _ref2.cancelText,
          render = _ref2.render;

      this.setState({
        title: title,
        message: message,
        confirm: confirm,
        confirmText: confirmText,
        cancelText: cancelText,
        render: render,
        loading: false,
        open: true
      });
      this.refs.modal.show();
    }
  }, {
    key: 'hideModal',
    value: function hideModal() {
      this.refs.modal.hide();
      this.setState({ open: false });
    }
  }, {
    key: 'confirm',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var result;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.state.open) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                this.setState({ loading: true });
                _context.next = 5;
                return this.state.confirm();

              case 5:
                result = _context.sent;

                if (!(result === false)) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt('return', this.setState({ loading: false }));

              case 8:
                this.hideModal();

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function confirm() {
        return _ref3.apply(this, arguments);
      }

      return confirm;
    }()
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.props.children,
        _react2.default.createElement(
          _OutlineModal2.default,
          { ref: 'modal', keyboard: true, modalStyle: styles.modal, contentStyle: styles.content },
          _react2.default.createElement(
            'div',
            { style: styles.title },
            this.state.title
          ),
          _react2.default.createElement(
            'div',
            { style: styles.message },
            this.state.render ? this.state.render() : this.state.message
          ),
          _react2.default.createElement(
            'div',
            { style: styles.buttons },
            _react2.default.createElement(
              _Button2.default,
              {
                disabled: this.state.loading,
                style: styles.cancelButton,
                onClick: this.hideModal },
              this.state.cancelText
            ),
            _react2.default.createElement(
              _Button2.default,
              { loading: this.state.loading, onClick: this.confirm, danger: true },
              this.state.confirmText
            )
          )
        )
      );
    }
  }]);
  return Modal;
}(_react2.default.Component), _class3.propTypes = {
  children: _propTypes2.default.node
}, _class3.childContextTypes = {
  showModal: _propTypes2.default.func
}, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'showModal', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class2.prototype, 'showModal'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'hideModal', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class2.prototype, 'hideModal'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'confirm', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class2.prototype, 'confirm'), _class2.prototype)), _class2)) || _class);
exports.default = Modal;


//////////////////
// WEBPACK FOOTER
// ./node_modules/orionsoft-parts/lib/components/Provider/Modal/index.js
// module id = 772
// module chunks = 21